import React from 'react'
import '../App.css'
import Bodycompracafeteria from './bodycompracafeteria'
export class Bodyappcompracafeteriabody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                <Bodycompracafeteria/>
            </div>    
        );
    }
}